import { render } from "./HeadPage.vue?vue&type=template&id=1993f384&scoped=true"
const script = {}

import "./HeadPage.vue?vue&type=style&index=0&id=1993f384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1993f384"]])

export default __exports__